import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'hasFileSelected',
    pure: true
  })
  export class PipeHasFileSelected implements PipeTransform {
    transform(selected: any, block?: any, total? :any): any {
        if(block == 'all')
          return selected.length >= total;
        else if(block instanceof Array)
          return selected.filter(item => !!block.filter(sel => item == sel).length).length >= block.length;
        else
          return !!selected.filter(item => item == block).length;
        
    }
  
  }